<template>
  <div class="external">
    <div class="content-hander">
      <div   class="home-logo"></div>
      <div @click="backHomePages" class="home-back"></div>
    </div>
    <div class="content-body">
       <div class="content-product">
         <el-row :gutter="0" type="flex"  style="min-height: 100%;">
           <el-col :span="6">
             <ul class="contentlist">
               <li @click="detailsOne" class="mouseout">ICU5000物联网控制器</li>
               <li @click="detailsTwo" class="mouseout">ICU5005物联网控制器</li>
               <li @click="detailsThree" class="mouseout">MIO-4AI-2AO-2TE模块</li>
               <li @click="detailsFour" class="mouseout">MIO-4RO-4DI-2AI-2TE模块</li>
               <li @click="detailsFive" class="mouseout">MIO-5RO-2BI盘管控制器</li>
               <li @click="detailsSix" class="mouseout">HTSGP室内环境传感器</li>
               <li @click="detailsSeven" class="mouseout">RS6多参数传感器</li>
               <li @click="detailsEight" class="mouseout">HT100室内温湿度传感器</li>
               <li @click="detailsNine" class="mouseout">HT200风管温湿度传感器</li>
               <li @click="detailsTen" class="mouseout">HMI4.0液晶面板</li>
               <li @click="detailsEleven" class="mouseout">NFC读卡器</li>
               <li @click="detailsTwelve" class="mouseout">智能执行器-VM10,15,20</li>
               <li class="mouseout"></li>
             </ul>
           </el-col>
           <el-col :span="18">
             <div class="content-mian">
               <h1>{{title}}</h1>
               <div class="content-img">
                 <img  :src="imgpath">
               </div>
               <div class="content-describe">
                 <p style="color: #6B777C">{{describe}}</p>
                 <!--<ul class="bullet">
                   <li>Nullam luctus neque sed urna mattis interdum. In hac habitasse platea dictumst.</li>
                   <li>Nullam luctus neque sed urna mattis interdum. In hac habitasse platea dictumst.</li>
                   <li>Nullam luctus neque sed urna mattis interdum. In hac habitasse platea dictumst.</li>
                   <li>Nullam luctus neque sed urna mattis interdum. In hac habitasse platea dictumst.</li>
                   <li>Nullam luctus neque sed urna mattis interdum. In hac habitasse platea dictumst.</li>
                   <li>Nullam luctus neque sed urna mattis interdum. In hac habitasse platea dictumst.</li>
                 </ul>-->
               </div>
             </div>
           </el-col>
         </el-row>

       </div>
    </div>
    <div class="content-tail"></div>
  </div>
</template>

<script>
export default {
  name: 'Demo',
  components: {

  },
  data () {
    return {
      title:'ICU5000物联网控制器',
      describe:`\xa0\xa0\xa0\xa0\xa0\xa0`+ '采用物联网技术的新一代智能建筑控制产品，用于取代楼宇自控系统、能耗计量、智能照明、门禁等传统控制设备，以基础场景控制为基点的通用型物联网现场控制设备。\n' +
        'ICU支持MQTT协议，具有远程编程能力，高可靠性设计使之可以在复杂环境下运行（如变频或其它强干扰源附近），通过工业现场总线（如MODBUS）对变频器、智能仪表、冷机、锅炉、电梯、热交换机组等大型机电设备实现控制管理，配合AIM其它智能组件可实现复杂设备或设备群组的控制管理。\n' +
        '与传统DDC比较有如下优势：\n' +
        '1、ICU为标准的物联网控制设备，以实现基础场景智能控制为目标，打破传统烟囱式控制模式，同时高速传输数据，数据量为传统DDC的几百倍。\n' +
        '2、ICU可在较为复杂的环境下工作，设计目标之一是用于低压配电系统联网，故与配电设备、拖动设备安装在一起仍能可靠运行。\n' +
        '3、ICU可支持所有物理层采用RS485通讯技术的设备，如门禁读卡设备、智能照明调光或回路控制设备等，通过编程可对被集成设备进行控制管理，具有极强的现场总线集成能力，是将传统控制设备及仪表、传感器物联网化的理想设备。',
      imgpath:'/static/img/homepage/5000.png'
    }

  },
  computed: {

  },
  mounted () {

  },
  methods: {
    controlProduct(){

    },
    backHomePages(){
      this.$router.push({name: 'homePage'})
    },
    detailsOne(){
      this.title = 'ICU5000物联网控制器'
      this.describe=`\xa0\xa0\xa0\xa0\xa0\xa0`+ '采用物联网技术的新一代智能建筑控制产品，用于取代楼宇自控系统、能耗计量、智能照明、门禁等传统控制设备，以基础场景控制为基点的通用型物联网现场控制设备。\n' +
        'ICU支持MQTT协议，具有远程编程能力，高可靠性设计使之可以在复杂环境下运行（如变频或其它强干扰源附近），通过工业现场总线（如MODBUS）对变频器、智能仪表、冷机、锅炉、电梯、热交换机组等大型机电设备实现控制管理，配合AIM其它智能组件可实现复杂设备或设备群组的控制管理。\n' +
        '与传统DDC比较有如下优势：\n' +
        '1、ICU为标准的物联网控制设备，以实现基础场景智能控制为目标，打破传统烟囱式控制模式，同时高速传输数据，数据量为传统DDC的几百倍。\n' +
        '2、ICU可在较为复杂的环境下工作，设计目标之一是用于低压配电系统联网，故与配电设备、拖动设备安装在一起仍能可靠运行。\n' +
        '3、ICU可支持所有物理层采用RS485通讯技术的设备，如门禁读卡设备、智能照明调光或回路控制设备等，通过编程可对被集成设备进行控制管理，具有极强的现场总线集成能力，是将传统控制设备及仪表、传感器物联网化的最理想设备。'
      this.imgpath = '/static/img/homepage/5000.png'
    },
    detailsTwo(){
      this.title = 'ICU5005物联网控制器'
      this.describe=`\xa0\xa0\xa0\xa0\xa0\xa0`+ 'ICU5005是采用MQTT协议的多功能增强型物联网边缘控制模块，该产品采用高防护等级金属外壳，快速插拔弹簧端子，可在复杂电磁环境下可靠工作，主要用于大型机电设备及配电设备的智能化监控、数据采集及网络化运行管理。\n' +
        'ICU5005支持腾讯微瓴物联网类操作系统，具备可编程功能且支持云端程序下载，专业人员可通过云平台实现对现场的快速技术支持，设备调试及控制逻辑优化。\n' +
        'ICU5005使用增强型高性能H743系列ARM处理器，具备专用HMI接口，用户可通过触摸式液晶屏就地实现对设备的控制操作。通过多达8路RS485接口，若干I/O及电气火灾传感器接口，可实现如冷水机组、锅炉及其它热源设备、空调机组、新风机组、电梯、变频器、低压配电盘柜、照明设备、多参数电力仪表等机电设备的智能化监控管理。'
      this.imgpath = '/static/img/homepage/5005.png'
    },
    detailsThree(){
      this.title = 'MIO-4AI-2AO-2TE模块'
      this.describe=`\xa0\xa0\xa0\xa0\xa0\xa0`+ 'MIO-4AI-2AO-2TE远程控制模块有8路I/O（4模拟量输入，2模拟量输出，2温度输入），采用标准MODBUS通讯协议,可选温湿度探针,可作为ICU5000系列物联网控制器的端口扩展，也可服务于任何采用标准MODBUS通讯协议的设备。\n' +
        'MIO-4AI-2AO-2TE使用全封闭式金属外壳，有较强的抗干扰能力，其作为远程扩展模块，搭配ICU5000系列物联网控制器，灵活运用在各种自动控制场合，如空调控制、水管压力采集、照明监测以及其它模拟量输入输出设备。'
      this.imgpath = '/static/img/homepage/MIO-4AI-2.png'
    },
    detailsFour(){
      this.title = 'MIO-4RO-4DI-2AI-2TE模块'
      this.describe=`\xa0\xa0\xa0\xa0\xa0\xa0`+ 'MIO-4RO-4DI-2AI-2TE模块有12路I/O（4路继电器输出，4路数字量输入，2路模拟量输入，2路温度输入），采用标准MODBUS通讯协议,可作为ICU5000系列物联网控制器的端口扩展，也可服务于任何采用标准MODBUS通讯协议的设备。\n' +
        'MIO-4RO-4DI-2AI-2TE使用全封闭式金属外壳，有较强的抗干扰能力，其作为远程扩展模块，搭配ICU5000系列物联网控制器，灵活运用在各种自动控制场合，如空调、风机盘管控制、照明控制以及其它需要状态采集、开关逻辑控制的设备。'
      this.imgpath = '/static/img/homepage/2AI.png'
    },
    detailsFive(){
      this.title = 'MIO-5RO-2BI盘管控制器'
      this.describe=`\xa0\xa0\xa0\xa0\xa0\xa0`+ 'MIO-5RO-2BI是有6路I/O的可编程控制模块，应用于风机盘管的智能运行控制，通过环境温度和设定温度的比较结果，控制风机盘管风机速度及电动阀工作状态，以达到调节环境温度、舒适和节能的目的。\n' +
        '控制器采用可直接安装在风机盘管本体上的标准工程用全金属快拆壳体，可连接标准金属保护软管接头，便于现场快速施工的同时为电子元件提供良好防护。\n' +
        '该控制器采用RS485通讯，可与ICU系列物联网边缘控制器配合，灵活运用于各种建筑空间控制场景，配合其它环境、安全模块实现建筑空间智慧管理。'
      this.imgpath = '/static/img/homepage/盘管控制器.png'
    },
    detailsSix(){
      this.title = 'HTSGP室内环境传感器'
      this.describe=`\xa0\xa0\xa0\xa0\xa0\xa0`+ 'HTSGP室内环境传感器是ICU物联网边缘控制器系列的配套组件，也可服务于任何采用标准modbus通讯协议的设备。它是一款集eCO2、TVOC（室温下饱和蒸气压超过了133．32pa的有机物）、温湿度于一体的多空气质量高精度传感器。\n' +
        'HTSGP室内环境传感器采用标准modbus通讯协议，具有参数设置定义功能，用户可通过软件定义传感器属性及通讯地址，可对所处环境进行实时侦测，使用方便，具有良好的稳定性；HTSGP室内环境传感器可广泛应用于便携式仪表、车载系统、空气质量监测设备、空气净化机、新风换气系统、空调、智能家居设备等场所。'
      this.imgpath = '/static/img/homepage/CO2.png'
    },
    detailsSeven(){
      this.title = 'RS6多参数传感器'
      this.describe=`\xa0\xa0\xa0\xa0\xa0\xa0`+ 'RS6多参数空气质量传感器是ICU物联网边缘控制器系列的配套组件，也可服务于任何采用标准modbus通讯协议的设备。它是一款集CO2、激光粉尘、温湿度、TVOC（室温下饱和蒸气压超过了133.32pa的有机物）及甲醛于一体的综合型空气质量传感器。\n' +
        'RS6多参数空气质量传感器采用标准modbus通讯协议，具有参数设置定义功能，用户可通过软件定义传感器属性及通讯地址，可对所处环境进行实时侦测，使用方便，具有良好的稳定性；RS6多参数空气质量传感器可广泛应用于空气质量监测设备、空气净化机、新风换气系统、空调、智能家居设备等场所。'
      this.imgpath = '/static/img/homepage/RS6.png'
    },
    detailsEight(){
      this.title = 'HT100室内温湿度传感器'
      this.describe=`\xa0\xa0\xa0\xa0\xa0\xa0`+ 'HT100室内温湿度传感器主要用于实时监测室内温度和湿度，采用标准MODBUS通讯协议,可作为ICU5000系列物联网控制器的配套组件，也可服务于任何采用标准MODBUS通讯协议的设备。 \n' +
        'HT100可通过拨码开关设置通讯地址，8位拨码开关可设置多达256个通讯地址，使用弹簧端子，简化施工工序,便于现场快速安装；其搭载的高精度传感器，误差小、精度高，在复杂环境下高效稳定运行，广泛应用于空气质量监测设备、空气净化机、空调、智能家居等场所。'
      this.imgpath = '/static/img/homepage/HT100.png'
    },
    detailsNine(){
      this.title = 'HT200风管温湿度传感器'
      this.describe=`\xa0\xa0\xa0\xa0\xa0\xa0`+ 'HT200智能温湿度传感器是物联网边缘控制器系列的配套组件，也可服务于任何采用标准modbus通讯协议的设备。该产品采用不锈钢探针，粉末冶金过滤网，封闭式壳体，防尘防水，搭配内部高精度传感器，保证设备在复杂环境下高效稳定运行。 \n' +
        'HT200采用标准modbus通讯协议，具有参数设置定义功能，用户可通过软件定义传感器属性及通讯地址；小直径（8mm）探针及快速插拔式弹簧端子简化了施工工序,便于现场快速安装；它主要用于测量风道内温湿度数据，也广泛应用于空气质量监测设备、空气净化机、新风换气系统、空调、智能家居设备等场所。'
      this.imgpath = '/static/img/homepage/HT200.png'
    },
    detailsTen(){
      this.title = 'HMI4.0液晶面板'
      this.describe=`\xa0\xa0\xa0\xa0\xa0\xa0`+ 'HMI 4.0是墙面安装的触摸式高分辨率液晶人机交互设备，可视角度广、触摸响应速度快，界面UI可根据用户需求精心定制。HMI 4.0采用标准MODBUS通讯协议，具有通讯距离远、兼容性好、抗干扰强、搭配控制器可实现任何场景组态等诸多优势。其主要用于实现建筑空间人机交互，取代传统墙面开关及温度控制设备；接口为双网口设计，即插即用，安装简便快捷。'
      this.imgpath = '/static/img/homepage/HMI-4.png'
    },
    detailsEleven(){
      this.title = 'NFC读卡器'
      this.describe=`\xa0\xa0\xa0\xa0\xa0\xa0`+ '本产品是针对物联网领域而开发的NFC通讯设备，用于手机与物联网系统实现近距通讯。具有稳定性好、灵活性高的特点。通过标准MODBUS协议接入ICU物联网边缘控制器实现出入口控制或人机交互操作。'
      this.imgpath = '/static/img/homepage/NFC.png'
    },
    detailsTwelve(){
      this.title = '智能执行器-VM10,15,20'
      this.describe=`\xa0\xa0\xa0\xa0\xa0\xa0`+ '采用伺服电机全金属减速机构为动力，扭矩范围10~20NM用于配套DN32~DN100精密控制球阀的电动执行机构，采用RS485通讯，具备可编程能力，便于用户根据需求预置应用程序，配置灵活的I/O，使产品适合多种流量/温度控制场景应用。\n'
      this.imgpath = '/static/img/homepage/智能执行器.png'
    },
    },
}
</script>
<style scoped>
  .external{
    position: relative;
    width: 100%;
    background-color: #FFFFFF;

    background-image: url("/static/img/homepage/light_grunge.jpg");
  }
  .content-hander{
    background: transparent url("/static/img/homepage/check_strip.png") repeat-x 0px -15px;
    height: 83px;
    position: relative;
  }
  .content-body{
    text-align: center;
    width: 100%;
    height: 850px;
    position: relative;
  }
  .content-tail{
    width: 100%;
    height: 50px;
    background-image: url("/static/img/homepage/check_strip11.png");
  }
  .content-product{
    margin: 0px auto;
    width: 55%;
    height: 80%;
    position: absolute;
    left: 23%;
    top: 7%;
  }
  .contentlist{
    float: left;
    background-color: transparent;
    font: normal 15px "CardoRegular",Serif;
    margin: 35px 10px 0 0;
    padding: 0px 0px 0px 0px;
    list-style: none;
  }
  .mouseout{
    border-top: 1px dotted #bbb;
    cursor: pointer;
    padding: 6px 15px;
    margin: 0;
    color: #6B777C;
  }
  .content-mian{
    width: 100%;
    height: 100%;
  }
  h1{
    font: normal 24px "CardoRegular",Serif;
    color: #555;
    padding: 8px 0px 32px 0px;
    margin-bottom: 30px;
    height: 1px;
    text-shadow: 1px 1px 0px #fcfcfc;
    letter-spacing: 1px;
    background: transparent url("/static/img/homepage/line.png") repeat-x 0px 30px;
  }
  .content-img{
    width: 90%;
    height: 200px;
    margin: 0 0 0px 3px;
    position: relative;
    left: 5%;
  }
  .content-img img{
    padding:10px;
    border:1px solid #8b8b8b;
    width: 100%;
    height: 100%;
    -moz-box-shadow:3px 3px 4px #000;
    -webkit-box-shadow:3px 3px 4px #000;
    box-shadow:3px 3px 4px #000;
    filter:progid:DXImageTransform.Microsoft.Shadow(Strength=4,Direction=135,Color='#000000');
  }
  .content-describe{
    width: 90%;
    height: 289px;
    margin: 0 0 0px 3px;
    padding-top: 17px;
    position: relative;
    left: 5%;
    overflow: hidden;
    text-align:left;
  }
  .bullet{
    padding: 0 0 20px 0;
    display: block;
    overflow: hidden;
  }
  .bullet li{
    line-height: 22px;
    list-style: none;
    display: block;
    padding-left: 15px;
    color: #6B777C;
  }
  .home-back{
    width: 25px;
    height: 20px;
    background-image: url("/static/img/homepage/home.png");
    position: absolute;
    background-size: 100% 100%;
    left: 95%;
    top: 35%;
    cursor: pointer;
  }
  .home-logo{
    width: 70px;
    height: 20px;
    background-image: url("/static/img/logOne.png");
    position: absolute;
    background-size: 100% 100%;
    left: 2%;
    top: 33%;
  }
</style>




// WEBPACK FOOTER //
// src/pages/homePageAssembly/controls.vue